
(function() {
  var result = { translations: { "sv": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tim", "hoursAndMinutes": "{{ hours }} tim {{ minutes }} min", "days": "{{ days }} dagar", "shortForm": { "seconds": "{{ seconds }}sek", "minutes": "{{ minutes }}min", "hours": "{{ hours }}tim", "days": "{{ days }}dagar", "hoursAndMinutes": "{{ hours }}tim {{ minutes }}min" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }} / {{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, anknytning {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sv": "static-7.1188"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1188",
    "ar-eg": "static-7.1188",
    "bg": "static-7.1188",
    "bn": "static-7.1188",
    "ca-es": "static-7.1188",
    "cs": "static-7.1188",
    "da": "static-7.1188",
    "de": "static-7.1188",
    "el": "static-7.1188",
    "en-gb": "static-7.1188",
    "en": "static-7.1188",
    "es-mx": "static-7.1188",
    "es": "static-7.1188",
    "et": "static-7.1188",
    "fi": "static-7.1188",
    "fr-ca": "static-7.1188",
    "fr": "static-7.1188",
    "he-il": "static-7.1188",
    "hi": "static-7.1188",
    "hr": "static-7.1188",
    "hu": "static-7.1188",
    "id": "static-7.1188",
    "it": "static-7.1188",
    "ja": "static-7.1188",
    "ko": "static-7.1188",
    "lt": "static-7.1188",
    "ms": "static-7.1188",
    "nl": "static-7.1188",
    "no": "static-7.1188",
    "pl": "static-7.1188",
    "pt-br": "static-7.1188",
    "pt-pt": "static-7.1188",
    "ro": "static-7.1188",
    "ru": "static-7.1188",
    "sk": "static-7.1188",
    "sl": "static-7.1188",
    "sv": "static-7.1188",
    "th": "static-7.1188",
    "tl": "static-7.1188",
    "tr": "static-7.1188",
    "uk": "static-7.1188",
    "vi": "static-7.1188",
    "x-pseudo": "static-7.1188",
    "zh-cn": "static-7.1188",
    "zh-hk": "static-7.1188",
    "zh-tw": "static-7.1188"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sv', {version: 'static-7.1188'}); }
})();


